import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { formatDollar } from "../../../../helper";

const useStyles = makeStyles((_theme) => ({
  cardContainer: {
    position: "absolute",
    top: "9vh",
    left: "29%",
    transform: "translateX(-50%)",
    height: "50vh",
    overflowY: "auto",
    scrollbarWidth: "none", // For Firefox
    "-ms-overflow-style": "none", // For Internet Explorer and Edge
    "&::-webkit-scrollbar": {
      display: "none", // For Chrome, Safari, and Opera
    },
  },
  card: {
    width: "25rem",
    borderRadius: "12px !important",
    borderRight: "2rem solid #349DD1",
    marginBottom: "0.625rem",
  },
  name: {
    color: "#349DD1",
    fontFamily: "Poppins, sans-serif",
    fontSize: "1rem",
    fontWeight: 700,
    lineHeight: 0.5,
  },
  KPI: {
    color: "#929497",
    fontFamily: "Poppins, sans-serif",
    fontSize: "0.6875rem",
    fontWeight: 500,
    lineHeight: 1.5,
  },
  KPIValue: {
    color: "#349DD1",
    fontFamily: "Poppins, sans-serif",
    fontSize: "0.875rem",
    fontWeight: 600,
    lineHeight: 1.5,
  },
  cardContent: {
    paddingTop: "0.3125rem",
    paddingBottom: "10px !important", // Remove bottom padding
  },
  cardDetails: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "0.25rem",
  },
  locationContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: "0.4375rem",
  },
  locationIcon: {
    marginRight: "0.3125rem",
  },
}));

const ToolTipCards = ({ open, name, data }) => {
  const classes = useStyles();
  const filteredData = data.filter((item) => item.LocationName === name);
  const remainingData = data.filter((item) => item.LocationName !== name);
  const sortedData = [...filteredData, ...remainingData];
  let path = window.location.pathname;

  const formatValue = (value, KPI) => {
    if (value === null || value === "NA") {
      return "NA";
    }
    if (value === 0) {
      return "0";
    }

    // Handle percentage-based KPIs
    const percentageKPIs = [
      "COF",
      "COF Last Week",
      "ST Capacity Utilization",
      "LT Capacity Utilization",
      "Detention spend %",
      "Incident rate",
      "Confirmed COF",
    ];
    if (percentageKPIs.includes(KPI)) {
      return `${Math.round(value)}%`; // Round to the nearest whole number and add '%'
    }

    // Handle currency-based KPIs
    const currencyKPIs = [
      "actual_cost_saving",
      "Cost of Fulfillment",
      "Cost per case",
      "STR_Rejection_Savings",
      "Working Capital Today",
      "Waste, Projected this week",
      "RPOOS",
      "Inv.on Hand",
      "Salvage Risk",
      "Potential Savings",
      "Forecast",
      "Awards",
      "Detention cost",
      "Shortage",
      "Revenue impact",
      "FInes avertable",
      "Actionable Revenue",
      "Unconfirmed QTY",
    ];
    if (currencyKPIs.includes(KPI)) {
      // let formattedValue = formatDollar(value);

      // Convert to millions for specific KPIs
      // const millionKPIs = [
      //   "Cost of Fulfillment",
      //   "STR_Rejection_Savings",
      //   "Working Capital Today",
      //   "Waste, Projected this week",
      //   "RPOOS",
      //   "Inv.on Hand",
      //   "Salvage Risk",
      //   "Potential Savings",
      //   "Forecast",
      //   "Awards",
      //   "Shortage",
      //   "Revenue impact",
      //   "FInes avertable",
      //   "Actionable Revenue",
      //   "Unconfirmed QTY",
      // ];
      // if (millionKPIs.includes(KPI)) {
      //   formattedValue = (formattedValue / 1000000).toFixed(2) + "M";
      // }

      // Add currency symbol and handle negative values
      return formatDollar(value);
    }
    // For any other KPI or value, return as is
    return value;
  };

  return open ? (
    <div className={classes.cardContainer}>
      {sortedData.map((item) => (
        <Card
          className={classes.card}
          style={{
            borderRight:
              item.LocationName === name
                ? "0.875rem solid #349DD1"
                : "0.875rem solid #7894A2",
          }}
          key={item.Plant}
        >
          <CardContent className={classes.cardContent}>
            <Typography className={classes.name}>
              {" "}
              {path !== "/ff" && `DC ${item.Plant}`}
            </Typography>
            <div className={classes.cardDetails}>
              {item.KPIData.map((key) => (
                <div key={key.KPI}>
                  <Typography className={classes.KPI}>{key.KPI}</Typography>
                  <Typography className={classes.KPIValue}>
                    {formatValue(key.value, key.KPI)}
                  </Typography>
                </div>
              ))}
            </div>
            {}
            <div className={classes.locationContainer}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="11"
                viewBox="0 0 12 11"
                fill="none"
                className={classes.locationIcon}
              >
                <path
                  d="M2.77465 8.00201C1.69275 8.18824 1 8.4744 1 8.7953C1 9.35651 3.11876 9.81146 5.73239 9.81146C8.34602 9.81146 10.4648 9.35651 10.4648 8.7953C10.4648 8.4744 9.77204 8.18824 8.69014 8.00201"
                  stroke="#929497"
                  strokeWidth="1.10915"
                  strokeLinecap="round"
                />
                <path
                  d="M7.20775 3.93175C7.20775 4.55633 6.54563 5.06265 5.72887 5.06265C4.91211 5.06265 4.25 4.55633 4.25 3.93175C4.25 3.30716 4.91211 2.80084 5.72887 2.80084C6.54563 2.80084 7.20775 3.30716 7.20775 3.93175Z"
                  stroke="#929497"
                  strokeWidth="1.10915"
                />
                <path
                  d="M6.47841 7.7734C6.27889 7.92035 6.01222 8.00249 5.73469 8.00249C5.45715 8.00249 5.19048 7.92035 4.99096 7.7734C3.1639 6.41958 0.715412 4.90722 1.90947 2.71155C2.55508 1.52437 4.10484 0.764709 5.73469 0.764709C7.36453 0.764709 8.91429 1.52437 9.5599 2.71155C10.7525 4.90445 8.30998 6.42424 6.47841 7.7734Z"
                  stroke="#929497"
                  strokeWidth="1.10915"
                />
              </svg>
              {path === "/ff" ? (
                <Typography className={classes.KPI}>
                  Lane {item.LaneID}
                </Typography>
              ) : path === "/slp" ? (
                <Typography className={classes.KPI}>{item.Location}</Typography>
              ) : (
                <Typography className={classes.KPI}>
                  {item.LocationName}
                </Typography>
              )}
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  ) : null;
};

export default ToolTipCards;
